import { TextPage } from '../components/TextPage';

// Words approved by Warren for #175, and a public statement: change them only
// with his word, and change the date with them. The known gaps are #173's.
export function AccessibilityPage() {
  return (
    <TextPage title="Accessibility" updated="November 2, 2026">
      <p>Kudu is built to meet WCAG 2.1 AA and Section 508.</p>
      <p>We check pages with automated scans and by keyboard, and we fix what we find.</p>
      <p>
        We know of gaps we are still fixing: some dialogs lose keyboard focus
        when they close, some text has too little contrast, and some controls
        are too small on a phone.
      </p>
      <p>
        If something stops you using Kudu, write to{' '}
        <a href="mailto:support@kudu.com">support@kudu.com</a> and we will work
        on it with you.
      </p>
    </TextPage>
  );
}
